import React from 'react';
import { useTranslation } from 'react-i18next';
import { getCurrentYear } from '@utils/datetime';

const CopyrightSection = () => {
  const { t } = useTranslation();

  return (
    <section className="border-top border-dark py-3 mt-5">
      <div className="text-center">
        <span className="d-block text-secondary">
          {t('common:brokerLicense.label')}: <br />
          {t('common:brokerLicense.general')} / {t('common:brokerLicense.life')}
        </span>
        <span className="text-secondary">
          © {getCurrentYear()} MGA Asia Insurance Brokers. {t('common:allRightsReserved')}.
        </span>
      </div>
    </section>
  );
};

export { CopyrightSection };
